import autoDeliveryMonitor from './auto-delivery-monitor'
import clients from './clients'
import priceTable from './price-table'
import deliveryDashboard from './delivery-dashboard'
import deliverySupplier from './delivery-supplier'
import lendingSchedulePanel from './lending-schedule-panel'
import promotion from './promotion'
import quotation from './quotation'
import order from './order'
import sale from './sale'
import event from './event'
import preparationDashboard from './preparation-dashboard'

export default {
  namespaced: true,
  modules: {
    autoDeliveryMonitor,
    clients,
    priceTable,
    deliveryDashboard,
    deliverySupplier,
    lendingSchedulePanel,
    quotation,
    order,
    promotion,
    sale,
    event,
    preparationDashboard,
  },
  state: {},
  mutations: {},
  actions: {},
}
